import React from "react";
import { motion } from "framer-motion";

import s from "./NamePlate.module.scss";

import namePlateTitleAi1 from "../../../assets/images/name_plate_title_ai1.png";
import namePlateTitleAi2 from "../../../assets/images/name_plate_title_ai2.png";
import namePlateTitleAi3 from "../../../assets/images/name_plate_title_ai3.png";

import namePlateTitleAi4_f1 from "../../../assets/images/name_plate_title_ai4_1.png";
import namePlateTitleAi4_f2 from "../../../assets/images/name_plate_title_ai4_2.png";

import namePlateTitleAiDeco from "../../../assets/images/name_plate_title_ai_deco.png";
import namePlateTitleAiDeco2 from "../../../assets/images/name_plate_title_ai_deco2.png";

const AiTitle = ({ id }) => {
    switch (id) {
        case 4:
            return <img src={namePlateTitleAi1} alt="" />;
        case 5:
            return (
                <>
                    <div className={s.decoStamps}>
                        <img
                            src={namePlateTitleAiDeco}
                            alt="name plate title"
                        />
                    </div>
                    <img src={namePlateTitleAi2} alt="" />
                </>
            );
        case 6:
            return (
                <>
                    <img src={namePlateTitleAi3} alt="" />
                    <div className={s.decoStars}>
                        <img
                            src={namePlateTitleAiDeco2}
                            alt="name plate title"
                        />
                    </div>
                    <div className={s.decoStampsMotion}>
                        <motion.div
                            className={s.decoStamps}
                            initial={{ x: "-245px" }}
                            animate={{
                                x: 0,
                            }}
                            transition={{
                                duration: 6,
                                repeat: Infinity,
                                ease: "linear",
                            }}
                        >
                            <div
                                className={s.stampBg}
                                style={{
                                    backgroundImage: `url(${namePlateTitleAiDeco})`,
                                }}
                            />
                            <div
                                className={s.stampBg}
                                style={{
                                    backgroundImage: `url(${namePlateTitleAiDeco})`,
                                }}
                            />
                        </motion.div>
                    </div>
                </>
            );
        case 7:
            return (
                <>
                    <motion.div
                        initial={{ opacity: 1 }}
                        animate={{ opacity: 0.25 }}
                        transition={{
                            duration: 0.75,
                            repeatType: "mirror",
                            repeat: Infinity,
                        }}
                        className="title-ai4"
                    >
                        <img
                            src={namePlateTitleAi4_f1}
                            alt="name plate title"
                        />
                    </motion.div>
                    <motion.div
                        initial={{ opacity: 1 }}
                        animate={{ opacity: 0 }}
                        transition={{
                            duration: 0.85,
                            repeatType: "mirror",
                            repeat: Infinity,
                        }}
                        className={s.decoStars}
                    >
                        <img
                            src={namePlateTitleAiDeco2}
                            alt="name plate title"
                        />
                    </motion.div>
                    <div className={s.decoStamps}>
                        <img
                            src={namePlateTitleAiDeco}
                            alt="name plate title"
                        />
                    </div>
                    <div style={{ zIndex: `-1` }}>
                        <img
                            src={namePlateTitleAi4_f2}
                            alt="name plate title"
                        />
                    </div>
                </>
            );
        default:
            return null;
    }
};

export default AiTitle;
